import { OkCancelDialogComponent } from './ok-cancel-dialog/ok-cancel-dialog.component';

export const MODALS = [OkCancelDialogComponent];

export * from './base-modal/base-modal';
export * from './ok-cancel-dialog/ok-cancel-dialog.component';
